import React from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";
import { useState } from "react";
import { useEffect } from "react";
import CSRCard from "./CSRCard";
import useSession from "../../hooks/useSession";
import CSRHighlightCard from "./CSRHighlightCard";

const CSRFocusPage = () => {
  const { CSRApi } = apiPath;
  const [user, loading] = useSession();
  const [csrData, uloading] = useFetch(CSRApi, true);
  const [filteredData, setFilteredData] = useState({});
  const [filteredData2, setFilteredData2] = useState({});

  useEffect(() => {
    const filtereddata = [...csrData].filter((item) => item.slug === "focus");
    setFilteredData(filtereddata);
  }, [csrData]);

  useEffect(() => {
    const filtereddata = [...csrData].filter(
      (item) => item.slug === "highlight"
    );
    setFilteredData2(filtereddata);
  }, [csrData]);

  if (uloading) {
    return <Loading />;
  }

  const { coverImage, _id } = csrData[0] ?? {};

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "url",
      defaultValue: coverImage?.url,
      required: true,
    },
    {
      elementType: "textField",
      label: "Banner Title",
      type: "file",
      name: "title",
      defaultValue: coverImage?.title,
      required: true,
    },
  ];

  const update = (data) => {
    data.coverImage = {
      title: data.title,
      url: data.url,
    };
    delete data.title;
    delete data.url;
    updateData(`${CSRApi}/${_id}`, data, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
      {/* focus list */}
      <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
        <h2 className="font-medium text-2xl mb-4">Our focus</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <CSRCard />
          {filteredData?.map((project, index) => (
            <CSRCard key={index} project={project} user={user.role} />
          ))}
        </div>
      </div>
      {/* highlights */}
      <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
        <h2 className="font-medium text-2xl mb-4">Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {/* <CSRHighlightCard /> */}
          {filteredData2?.map((project, index) => (
            <CSRHighlightCard key={index} project={project} user={user.role} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CSRFocusPage;
